import axiosInstance from '../../utils/axiosInstance';
import endpoints from '../../utils/endpoints';

/**
 * Fetches app version (single type). Returns { schema } for deep links.
 * Call without platform to get schema only.
 */
const getAppVersion = async (headers) => {
  const { data } = await axiosInstance.get(endpoints.appVersion, { headers });
  return data;
};

const client = { getAppVersion };

export default client;
